<template>
	<div class="login-container">
		<el-form
			ref="loginForm"
			:model="loginForm"
			:rules="loginRules"
			class="login-form"
			auto-complete="on"
			label-position="left"
		>
			<el-form-item prop="account">
				<span class="svg-container">
					<svg-icon icon-class="user" />
				</span>
				<el-input
					v-model="loginForm.account"
					name="account"
					type="text"
					auto-complete="on"
					placeholder="请输入用户名"
				/>
			</el-form-item>
			<el-form-item prop="password">
				<span class="svg-container">
					<svg-icon icon-class="password" />
				</span>
				<el-input
					:type="pwdType"
					v-model="loginForm.password"
					name="password"
					auto-complete="on"
					placeholder="请输入密码"
					@keyup.enter.native="handleLogin"
				/>
				<span class="show-pwd" @click="showPwd">
					<svg-icon icon-class="eye" />
				</span>
			</el-form-item>
			<el-form-item>
				<el-button
					:loading="loading"
					type="primary"
					style="width:100%;"
					@click.native.prevent="handleLogin"
					>登录</el-button
				>
			</el-form-item>
		</el-form>
		<a class="footer" href="http://www.beian.miit.gov.cn/" target="_blank"
			>京ICP备17074261号-2</a
		>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loginForm: {
				account: '',
				password: ''
			},
			loginRules: {
				account: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [
					{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (value.length < 5) {
								callback(new Error('密码不能小于5位'))
							} else {
								callback()
							}
						}
					}
				]
			},
			loading: false,
			pwdType: 'password',
			redirect: ''
		}
	},
	watch: {
		$route: {
			handler: function(route) {
				if (route.query) {
					this.redirect = route.query.redirect
				}
			},
			immediate: true
		}
	},
	mounted() {},
	methods: {
		showPwd() {
			if (this.pwdType === 'password') {
				this.pwdType = ''
			} else {
				this.pwdType = 'password'
			}
		},
		handleLogin() {
			this.$refs.loginForm.validate(async valid => {
				if (valid) {
					this.loading = true
					try {
						await this.$store.dispatch('startLogin', this.loginForm)
						this.$message({
							message: '登录成功！',
							type: 'success'
						})
						this.$router.push({ path: this.redirect || '/' })
					} finally {
						this.loading = false
					}
				} else {
					return false
				}
			})
		}
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
	background: url('../../assets/images/login_bg.jpg') no-repeat;
	background-size: cover;
	position: fixed;
	height: 100%;
	width: 100%;
	min-width: 1200px;
	.el-input {
		display: inline-block;
		height: 47px;
		width: 85%;
		::v-deep input {
			background: transparent;
			border: 0px;
			-webkit-appearance: none;
			border-radius: 0px;
			padding: 12px 5px 12px 15px;
			color: $light_gray;
			height: 47px;
			&:-webkit-autofill {
				box-shadow: 0 0 0px 1000px $bg inset !important;
				-webkit-text-fill-color: #fff !important;
			}
		}
	}
	.el-form-item {
		border: 1px solid rgba(255, 255, 255, 0.4);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 5px;
		color: #454545;
	}
	.login-form {
		position: absolute;
		left: 0;
		right: 0;
		width: 520px;
		max-width: 100%;
		padding: 35px 35px 15px 35px;
		margin: 200px auto;
	}
	.tips {
		font-size: 14px;
		color: #fff;
		margin-bottom: 10px;
		span {
			&:first-of-type {
				margin-right: 16px;
			}
		}
	}
	.svg-container {
		padding: 6px 5px 6px 15px;
		color: $dark_gray;
		vertical-align: middle;
		width: 30px;
		display: inline-block;
	}
	.title {
		font-size: 26px;
		font-weight: 400;
		color: $light_gray;
		margin: 0px auto 40px auto;
		text-align: center;
		font-weight: bold;
	}
	.show-pwd {
		position: absolute;
		right: 10px;
		top: 7px;
		font-size: 16px;
		color: $dark_gray;
		cursor: pointer;
		user-select: none;
	}
	.footer {
		position: fixed;
		left: 50%;
		transform: translateX(-50%);
		padding: 16px;
		bottom: 16px;
		font-size: 12px;
		color: #fff;
		cursor: pointer;
	}
	.verify-input {
		.el-input {
			width: 60%;
		}
	}
	.vcode-warpper {
		position: relative;
		height: 52px;
		font-size: 0;
		cursor: pointer;
		.vcode-img {
			height: 100%;
			width: 100%;
		}
		.vcode-mask {
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			width: 100%;
			text-align: center;
			padding-top: 10px;
			background: rgba(255, 255, 255, 0.5);
			opacity: 0;
			transition: opacity 1s;
			&:hover {
				opacity: 1;
			}
			.refresh_btn {
				font-size: 26px;
			}
		}
	}
}
</style>
